import { createRouter, createWebHistory } from "vue-router"
import validateToken from "../services/validateToken"

import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import SsoCallback from '../views/SsoCallback.vue'

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/sso/callback",
    name: "SsoCallback",
    component: SsoCallback
  },
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard
  }
]

export const publicRoutes = ["Login", "SsoCallback", "Calendar Survey"]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (__DEMO_MODE__) {
    if (to.name === "Login" || to.name === "SsoCallback") {
      next({ name: "Dashboard" })
      return
    }
    await validateToken()
    next()
    return
  }

  const authenticationRequired = !publicRoutes.includes(to.name)
  if (authenticationRequired) {
    const valid = await validateToken()
    if (!valid) {
      localStorage.removeItem("access-token")
      localStorage.removeItem("carl-user")
      /* Send users who failed authentication check to login screen */
      next({ name: "Login" })
      return
    }
  }
  next()
})

export default router
